// Small helpers: ICS export, share URLs, formatters.
export function formatDate(iso, lang = "en") {
  if (!iso) return "";
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  return d.toLocaleDateString(lang === "de" ? "de-DE" : "en-GB",
    { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
}
export function formatRange(e, lang = "en") {
  if (e.start_date === e.end_date) return formatDate(e.start_date, lang);
  return `${formatDate(e.start_date, lang)} — ${formatDate(e.end_date, lang)}`;
}
function pad(n) { return String(n).padStart(2, "0"); }
function toICSDate(dateStr, timeStr) {
  const [y, mo, d] = dateStr.split("-").map(Number);
  const [h, mi] = (timeStr || "20:00").split(":").map(Number);
  return `${y}${pad(mo)}${pad(d)}T${pad(h)}${pad(mi)}00`;
}
export function buildICS(e) {
  const uid = `${e.event_id}@soulradar`;
  const dtstart = toICSDate(e.start_date, e.start_time);
  const dtend = toICSDate(e.end_date, e.end_time);
  const now = new Date();
  const dtstamp = `${now.getUTCFullYear()}${pad(now.getUTCMonth()+1)}${pad(now.getUTCDate())}T${pad(now.getUTCHours())}${pad(now.getUTCMinutes())}00Z`;
  const url = `${window.location.origin}/events/${e.slug}`;
  const lines = [
    "BEGIN:VCALENDAR","VERSION:2.0","PRODID:-//Soul Radar//EN",
    "BEGIN:VEVENT",
    `UID:${uid}`,`DTSTAMP:${dtstamp}`,
    `DTSTART:${dtstart}`,`DTEND:${dtend}`,
    `SUMMARY:${escapeIcs(e.name)}`,
    `LOCATION:${escapeIcs(`${e.venue}, ${e.address}, ${e.city}, ${e.country}`)}`,
    `DESCRIPTION:${escapeIcs(e.short_description || "")}\\n${url}`,
    `URL:${url}`,
    "END:VEVENT","END:VCALENDAR",
  ];
  return lines.join("\r\n");
}
function escapeIcs(s) { return String(s).replace(/([,;\\])/g, "\\$1").replace(/\n/g, "\\n"); }
export function downloadICS(e) {
  const blob = new Blob([buildICS(e)], { type: "text/calendar" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = `${e.event_id.includes("-") ? e.event_id : e.slug}.ics`; a.click();
  URL.revokeObjectURL(url);
}
export function googleCalendarUrl(e) {
  const dt = `${toICSDate(e.start_date, e.start_time)}/${toICSDate(e.end_date, e.end_time)}`;
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: e.name,
    dates: dt,
    details: `${e.short_description || ""}\n${window.location.origin}/events/${e.slug}`,
    location: `${e.venue}, ${e.address}, ${e.city}, ${e.country}`,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
export function shareUrls(e) {
  const url = `${window.location.origin}/events/${e.slug}`;
  const preview = `${process.env.REACT_APP_BACKEND_URL}/api/share/${e.slug}`;
  const text = `${e.name} — ${e.city}, ${e.country}`;
  return {
    url, preview,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(text + " " + preview)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(preview)}`,
    sms: `sms:?&body=${encodeURIComponent(text + " " + preview)}`,
    instagram: "https://www.instagram.com/",
    mail: `mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(text + "\n" + url)}`,
  };
}

const COUNTRIES = { "united kingdom": ["United Kingdom", "Vereinigtes Königreich"], "uk": ["United Kingdom", "Vereinigtes Königreich"], "germany": ["Germany", "Deutschland"], "deutschland": ["Germany", "Deutschland"],
  "netherlands": ["Netherlands", "Niederlande"], "niederlande": ["Netherlands", "Niederlande"], "belgium": ["Belgium", "Belgien"], "belgien": ["Belgium", "Belgien"], "france": ["France", "Frankreich"], "frankreich": ["France", "Frankreich"],
  "spain": ["Spain", "Spanien"], "spanien": ["Spain", "Spanien"], "italy": ["Italy", "Italien"], "italien": ["Italy", "Italien"], "austria": ["Austria", "Österreich"], "österreich": ["Austria", "Österreich"], "switzerland": ["Switzerland", "Schweiz"], "schweiz": ["Switzerland", "Schweiz"],
  "usa": ["USA", "USA"], "united states": ["USA", "USA"], "sweden": ["Sweden", "Schweden"], "schweden": ["Sweden", "Schweden"], "denmark": ["Denmark", "Dänemark"], "dänemark": ["Denmark", "Dänemark"], "norway": ["Norway", "Norwegen"], "norwegen": ["Norway", "Norwegen"],
  "ireland": ["Ireland", "Irland"], "irland": ["Ireland", "Irland"], "poland": ["Poland", "Polen"], "polen": ["Poland", "Polen"], "portugal": ["Portugal", "Portugal"], "czech republic": ["Czech Republic", "Tschechien"], "tschechien": ["Czech Republic", "Tschechien"], "japan": ["Japan", "Japan"], "australia": ["Australia", "Australien"], "australien": ["Australia", "Australien"] };
export function countryName(c, lang) { const hit = COUNTRIES[(c || "").trim().toLowerCase()]; return hit ? hit[lang === "de" ? 1 : 0] : c; }
